module.exports = __webpack_public_path__ + "media/images/emblems/Paudex-coat_of_arms-c8da40a26a632766ca9ba04d0b742e4a.svg";